import React from 'react';

// Hero product visual - premium Himalayan showcase.
// Fills the entire available column height with a premium banner feel.
const HERO_PRODUCT_IMG = '/hero-himalaya.png';

const PosDevice = () => {
  return (
    <div className="relative w-full h-full min-h-[520px] lg:min-h-[640px]">
      {/* Ambient radial glow behind the image */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[520px] h-[520px] rounded-full bg-purple-400/25 blur-3xl" />
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-[360px] h-[360px] rounded-full bg-violet-500/25 blur-3xl" />
      </div>

      {/* Edge-to-edge premium banner card */}
      <div className="relative w-full h-full rounded-[32px] overflow-hidden premium-shadow floating">
        <img
          src={HERO_PRODUCT_IMG}
          alt="PhonePe Smart POS - Built for the Himalayas"
          className="w-full h-full object-cover select-none"
          style={{ objectPosition: '30% center' }}
          draggable={false}
          loading="eager"
        />
        {/* Subtle inner ring for premium finish */}
        <div className="pointer-events-none absolute inset-0 rounded-[32px] ring-1 ring-white/20" />
      </div>
    </div>
  );
};

export default PosDevice;
